import * as React from 'react';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { Container, Drawer } from '@mui/material';
import { useState } from 'react';

const drawerBleeding = 56;




const StyledBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.customBackground.main
}));

const Puller = styled(Box)(({ theme }) => ({
  width: 60,
  height: 6,
  backgroundColor: grey[900],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
}));


export default function MobileBottomDrawer(props: any) {
  

  const toggleDrawer = (newOpen: boolean) => () => {
    props.setOpen(newOpen);
};


  return (
    <>
      <Box sx={{
        ".MuiDrawer-root > .MuiPaper-root": {
          height: `calc(50% - ${drawerBleeding}px+20px)`,
          overflow: "visible"
        }
      }}>

        <SwipeableDrawer
          sx={{
            '& .MuiDrawer-paper': {
              overflow: "visible",
              width: "100%",
              height: `calc(90% - ${drawerBleeding}px)`,
            }
          }}
          BackdropProps = {{
            invisible:true,
        }}
          anchor="bottom"
          open={props.open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          swipeAreaWidth={drawerBleeding}
          disableSwipeToOpen={false}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <StyledBox
            sx={{
              position: 'absolute',
              top: -drawerBleeding + 5,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              visibility: 'visible',
              right: 0,
              left: 0,
            }}
          >
            <Puller />
            <Container sx={{ p: 3.5, }}></Container>
          </StyledBox>
          {props.children}
        </SwipeableDrawer>
      </Box>
    </>
  );
}